<template>
  <div class="section-home">
    <div v-if="isLoadingSwiper">
      <loading />
    </div>
    <div v-show="!isLoadingSwiper">
      <BannerSwiper
          @click-item="handleClickProduct"
          :list-products="listProducts"
      />
    </div>
    <div v-if="isLoadingMarkets && !isLoadingSwiper">
      <loading />
    </div>
    <div v-if="!isLoadingMarkets">
      <Ticket
          :loading-book-ticket="loadingBookTicket"
          :list-games="listGamesToShow"
          :total-page="totalPerPage"
          :is-load-more="isLoadMore"
          :search-loto="searchLoto"
          :data-dropdown="filterDropdown"
          @changeDropdown="changeFilterDropdown"
          @handleSearch="handleSearchLoto"
          @handleExpired="handleExpired"
          @handleBookBet="handleBookBet"
          :book-bet="bookBet"
          @load-more="loadMoreGames"
      />
    </div>
    <ModalCommon
        v-if="showModalBetslip"
        @close="showModalBetslip = false"
        @login="handleLogin"
        @process-bet="handleProcessBet"
        @book-a-bet="handleBookABet"
        :isClassModalCustom="isModalCustomClass"
    >
      <YourBetslip
          v-bind:dataBetslip="listBetslips"
          v-bind:commonStake="commonStake"
          v-bind:totalStake="totalStake"
          :loading="loadingProcessBet"
          :loading-boot-a-bet="loadingBootABet"
          :is-disable-process-bet="isDisableProcessBet"
          :is-show-error-expired="isShowErrorExpired"
          :is-show-res-book-a-bet="isShowResBookABet"
          :booking-code-boot-a-bet="bookingCodeBootABet"
          @changeStake="handleChangeStake"
          @removeItemBetslip="handleRemoveItemBetslip"
          @removeAllBetslip="handleRemoveAllBetslips"
          @removeDrawsExpired="removeDrawsExpired"
          @moveToNextDraw="moveToNextDraw"
          @addClassModalClass="handleToggleClassModal"
      />
    </ModalCommon>
    <ModalCommon
        v-if="showModalProcessBet"
        @close="showModalProcessBet = false"
        @click-item="handleConfirmItem"
        @removeBetslip="listBetslips=[]"
    >
      <BetConfirmation />
    </ModalCommon>
    <ModalCommon
        v-if="showModalConfirmBet"
        @close="showModalConfirmBet = false"
        :refConfirm="refBetConfirmationDetail"
    >
      <BetConfirmationDetail />
    </ModalCommon>
  </div>
</template>
<script>
import BannerSwiper from './BannerSwiper';
import Ticket from './Ticket';
import DrawsService from '@/services/draws.service';
import moment from "moment";
import CountriesService from "@/services/countries.service";
import Loading from '@/components/common/loading/Loading.vue'
import TransactionService from "@/services/transaction.service";
import YourBetslipMixin from "@/mixins/betslip/your-betslip-mixin";
import ModalCommon from '@/components/common/modal/modal-common.vue';
import YourBetslip from "@/views/ticket/betslip/YourBetslip";
import BetConfirmationDetail from "@/views/ticket/betslip/BetConfirmationDetail";
import BetConfirmation from "@/views/ticket/betslip/BetConfirmation";
export default {
  mixins: [YourBetslipMixin],
  components: {
    BannerSwiper,
    Ticket,
    Loading,
    ModalCommon,
    YourBetslip,
    BetConfirmationDetail,
    BetConfirmation
  },
  data() {
    return {
      isLoadingSwiper: false,
      isLoadingMarkets: false,
      bookBet: '',
      searchLoto: '',
      listGames: [],
      listGamesToShow: [],
      perPage: 30,
      totalPerPage: 30,
      gameCount: 0,
      isLoadMore: true,
      countries: [],
      listProducts: [],
      filterDropdown: [
        {
          value: 'alphabetical',
          title: 'Alphabetical',
          active: false
        },
        {
          value: 'time',
          title: 'Time',
          active: false
        }
      ]
    }
  },
  created() {
    const parameters = this.$route.query
    if (parameters) {
      this.$store.dispatch('initDataCustomer', parameters)
    }
    this.getDraws();
    this.getCarouselProducts();
  },
  methods: {
    getCarouselProducts() {
      this.isLoadingSwiper = true;
      CountriesService.getCountries().then(res => {
        this.isLoadingSwiper = false;
        this.listProducts = Object.entries(res).map(item =>({country_slug: item[0], country_name: item[1]}))
        console.log('this.listProducts', this.listProducts, res);
      })
    },
    handleClickProduct(item) {
      this.listGamesToShow = this.listGames.filter(game => game.country_name === item.country_name)
      this.isLoadMore = this.listGamesToShow.length > this.perPage ;
    },
    changeFilterDropdown(index) {
      this.filterDropdown.forEach((value, i) => {
        value.active = i === index ? !value.active : false
        if(index === 0 && value.active) {
          this.listGamesToShow = this.listGames.sort((a, b) => a.name.localeCompare(b.name))
        } else if(index === 1 && value.active) {
          this.listGamesToShow = this.listGames.sort((a, b) => new Date(this.formatDateTime(a.cutoff)) - new Date(this.formatDateTime(b.cutoff)))
        }
      })
    },
    formatDateTime(time) {
      return moment(time, "yyyy-MM-dd HH:mm:ss.SSS").toDate();
    },
    handleSearchLoto(value) {
      this.listGamesToShow = this.listGames.filter(obj => JSON.stringify(obj).toLowerCase().includes(value.toLowerCase()));
      this.isLoadMore = this.listGamesToShow.length > this.perPage ;
    },
    handleBookBet(value) {
      this.loadingBookTicket = true;
      TransactionService.apiBookedBet(value).then(res=> {
        let listBetslips = [];
        if (res.status === "success") {
          const listBookedBet = res.items;
          listBookedBet.forEach(item => {
            item.bets.forEach(bet=> {
              for (const property in bet) {
                const value = bet[property];
               value.selection.forEach(selection => {
                 let maxStake = 0;
                 if(selection.maxPayout) {
                   maxStake = parseInt(selection.maxPayout) / parseInt(selection.odds)
                 } else {
                   if(this.accountSettings.payout_max) {
                     maxStake = parseInt(this.accountSettings.payout_max) / selection.odds
                   }
                 }
                  listBetslips.push({
                    Extra: "", // todo
                    Main: [],
                    MaxStake: maxStake,
                    betType: value.betType,
                    bets: {
                      description: selection.description,
                      summary: selection.summary,
                      specifier: selection.specifier
                    },
                    drawDate: item.draw_date,
                    drawName: item.name,
                    draws: selection.draws,
                    isBetExpired: false,
                    isFreeBet: selection.isFreeBet,
                    market: property,
                    maxPayout: selection.maxPayout,
                    moreDrawName: selection.summary,
                    newDrawName: selection.newDrawName, // todo update name time
                    numOfBets: selection.numOfBets,
                    numbers: selection.numbers,
                    odds: selection.odds,
                    outcome: selection.outcomeId,
                    paid: "",
                    slug: item.slug,
                    stake: selection.stake,
                    stakeTaxAmount: "0.0000000000",
                    startDrawId: item.draw_id,
                    summary: selection.summary,
                    systemBets: selection.systemBets,
                    text: selection.text,
                    toWin: selection.to_win,
                    wheelingId: selection.wheelingId
                  })
                })
              }
            })
          })
          this.loadingBookTicket = false;
          this.listBetslips = listBetslips;
          localStorage.setItem('yourBetslip', JSON.stringify(this.listBetslips))
          this.$store.dispatch('changeBadgeNumber', this.listBetslips.length);
          this.showModalBetslip = true;
        } else {
          this.loadingBookTicket = false;
          this.$toast.error(res.message, {position: 'top-right'});
        }
      })
    },
    handleExpired() {
      console.log('handle expired draw:')
      this.getDraws()
    },
    getDraws() {
      this.isLoadingMarkets = true;
      DrawsService.apiGetDraws().then(res => {
        this.isLoadingMarkets = false;
        this.listGames = res;
        this.listGamesToShow = res;
        this.isLoadMore = this.listGames.length > this.perPage ;
        this.gameCount = this.listGames.length;
      })
    },
    loadMoreGames() {
      if (this.totalPerPage + this.perPage < this.gameCount) {
        this.totalPerPage = this.totalPerPage + this.perPage;
      } else {
        this.totalPerPage = this.gameCount;
        this.isLoadMore = false;
      }
    }
  }
}
</script>
<style scoped>
.section-home {
  padding: 20px 0;
}
@media (max-width: 768px) {
  .section-home {
    padding: 10px 0;
  }
}
</style>
